import { render, staticRenderFns } from "./DeliverableListContacts.vue?vue&type=template&id=728ff4a4&"
import script from "./DeliverableListContacts.vue?vue&type=script&lang=js&"
export * from "./DeliverableListContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports